(function (window, document) {
  "use strict";

  var DNB = window.DNB;

  // Özel sayfa: İletişim / Bize Ulaşın — contact.min.js.
  // common + inner üstüne eklenir; yalnızca iletişim formu davranışı.
  document.addEventListener("DOMContentLoaded", function () {
    DNB.safeInit("ContactForm", function () { DNB.ContactForm.init(); });
    DNB.safeInit("ContactMaps", function () {
      var root = document.querySelector(".contact__info");
      if (!root) return;
      var key = root.getAttribute("data-google-maps-key") || "";
      root.querySelectorAll("iframe[data-src]").forEach(function (frame) {
        var template = frame.getAttribute("data-src") || "";
        if (key) template = template.split("{{GoogleAPIkey}}").join(key);
        if (template && template.indexOf("{{GoogleAPIkey}}") === -1) frame.src = template;
      });
    });
  });
})(window, document);
